export const FETCH_AUDIENCES = 'audiences/FETCH_AUDIENCES'
export const ADD_AUDIENCE = 'audiences/ADD_AUDIENCE'
export const ADD_SELECTED_AUDIENCE = 'audiences/ADD_SELECTED_AUDIENCE'
export const REMOVE_AUDIENCE = 'audiences/REMOVE_AUDIENCE'
export const CLEAR_AUDIENCE_STATE = 'audiences/CLEAR_AUDIENCE_STATE'
